import { styled } from "../../lib/styles/stitches.config";

const HorizontalRule = styled("hr", {
  margin: "1.5em auto",
  height: "0.175em",
  border: 0,
  backgroundColor: "$light",
});

export default HorizontalRule;
